/**
 * Accès sécurisé au localStorage/sessionStorage.
 * Quand le navigateur bloque le stockage (Tracking Prevention, mode privé, iframe cross-origin),
 * les appels lèvent une exception. On évite de faire planter l'app et de spammer la console.
 */

function safeStorage(store) {
  try {
    if (typeof store === 'undefined' || store === null) return null;
    const test = '__storage_test__';
    store.setItem(test, test);
    store.removeItem(test);
    return store;
  } catch {
    return null;
  }
}

const _local = typeof localStorage !== 'undefined' ? safeStorage(localStorage) : null;
const _session = typeof sessionStorage !== 'undefined' ? safeStorage(sessionStorage) : null;

export function getLocalItem(key) {
  if (!_local) return null;
  try {
    return _local.getItem(key);
  } catch {
    return null;
  }
}

export function setLocalItem(key, value) {
  if (!_local) return;
  try {
    _local.setItem(key, value);
  } catch { /* Tracking Prevention / blocage stockage */ }
}

export function removeLocalItem(key) {
  if (!_local) return;
  try {
    _local.removeItem(key);
  } catch { /* ignoré */ }
}

export function clearSession() {
  if (!_session) return;
  try {
    _session.clear();
  } catch { /* ignoré */ }
}

export function getSessionItem(key) {
  if (!_session) return null;
  try {
    return _session.getItem(key);
  } catch {
    return null;
  }
}

export function setSessionItem(key, value) {
  if (!_session) return;
  try {
    _session.setItem(key, value);
  } catch { /* ignoré */ }
}

export function removeSessionItem(key) {
  if (!_session) return;
  try {
    _session.removeItem(key);
  } catch { /* ignoré */ }
}

/** Vérifie si le stockage est disponible (pour afficher un message si besoin). */
export function isStorageAvailable() {
  return !!_local;
}
